<template>
  <div class="terms">
    <div class="h1 mt-2 flex justify-content-center">
      Payment Terms
    </div>
    <div class="h5 mt-5 ms-4 me-4">
      <p>
        RWA.capital (hereinafter -- the Company) shall be regulated by the Dubai
        Financial Services Authority (DFSA). Subject to the DFSA requirements,
        the Company is to hold client money in segregated client money accounts
        with its banking partner.
      </p>

      <p>
        The Rules for funding and withdrawals shall be as set forth below:
      </p>

      <ol class="mt-3">
        <li>
          Funding the respective RWA.capital Account shall be allowed from
          your own bank account only or through another payment method
          registered in your name. No third-party payments shall be accepted.
        </li>

        <li class="mt-3">
          Credit card payments shall be permitted only provided you are
          classified as a Professional Investor under the duly applicable DFSA
          rules.
        </li>

        <li class="mt-3">
          To maintain access to your funds, you shall at all times comply with
          the Company's Know Your Customer (KYC) and Anti-Money Laundering
          (AML) procedures. These procedures may be subject to update from
          time to time. In the event you are classified as a High Risk Client,
          the Company shall notify you respectively.
        </li>

        <li class="mt-3">
          Should funds be received from a third party, or if for any other
          reason (as set by the Company at its sole discretion) the Company is
          unable to accept such payment, the transaction shall be reversed or
          cancelled with the funds to be returned to the originating account
          (or the same payment method), with any applicable fees and charges
          to be deducted. In case a transaction is reversed, additional
          deductions may be applied by your sending bank or intermediary
          banks; accordingly, the amount returned may be below the amount
          originally funded.
        </li>

        <li class="mt-3">
          Where funds deposited via credit card have not been invested through
          RWA.capital, a penalty fee of up to 2.50% of the total withdrawal
          amount may be charged upon withdrawal. This fee shall apply
          exclusively to the withdrawal of uninvested funds, as the Company
          incurs a 2.50% fee from the payment provider for all top-ups
          executed via electronic card payments.
        </li>

        <li class="mt-3">
          The penalty fee shall not apply to withdrawals of investment
          proceeds, including (without limitation) rental payments or sale
          proceeds.
        </li>

        <li class="mt-3">
          Withdrawals to international bank accounts shall be available
          subject to a minimum withdrawal amount of AED 100.
        </li>
      </ol>

      <p class="mt-4 text-muted fst-italic">
        These Payment Terms form an integral part of the RWA.capital Terms of Use.
      </p>
    </div>
  </div>
</template>

<script setup>
import { checkAccess, scope } from "@/help/accessData";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
onMounted(() => {
  if (checkAccess(scope.notRwa)) {
    router.push({ name: "page not found" });
  }
});
</script>

<style scoped lang="scss">
.terms {
  background-color: var(--main-color);
  padding-bottom: 10px;

  .header {
    display: grid;
    grid-template-columns: 33% auto 33%;
    padding-right: 20px;
  }
}

ol {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
  padding-left: 0.5rem;

  li {
    margin-bottom: 0.75rem;
    padding-left: 0.5rem;
  }
}

.text-muted {
  color: #6c757d !important;
}

.fst-italic {
  font-style: italic;
}
</style>